import { useState } from "react";


const PASSWORD = "rxw2026";

export default function Password({ children }) {
    const [password, setPassword] = useState("");
    const [isAuthorized, setIsAuthorized] = useState(false);
    const [hasError, setHasError] = useState(false);

    const handleSubmit = (event) => {
        event.preventDefault();

        if (password === PASSWORD) {
            setIsAuthorized(true);
            setHasError(false);
            return;
        }

        setHasError(true);
    };

    if (isAuthorized) {
        return children;
    }

    return (
        <main style={styles.page}>
            <form onSubmit={handleSubmit} style={styles.form}>
                <h1 style={styles.heading}>Protected project</h1>
                <label htmlFor="project-password">Enter password to continue</label>
                <input
                    id="project-password"
                    type="password"
                    value={password}
                    onChange={(event) => {
                        setPassword(event.target.value);
                        setHasError(false);
                    }}
                    autoComplete="current-password"
                    autoFocus
                    style={styles.input}
                />
                <button className="password-button" type="submit" style={styles.button}>Continue</button>
                {hasError && <p role="alert" style={styles.error}>Incorrect password</p>}
            </form>
        </main>
    );
}

const styles = {
    page: {
        boxSizing: "border-box",
        width: "100%",
        height: "100dvh",
        minHeight: "100svh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "2rem",
        overflow: "hidden",
        backgroundColor: "#fff9ef",
    },
    form: {
        display: "flex",
        flexDirection: "column",
        gap: "1rem",
        width: "100%",
        maxWidth: "24rem",
    },
    heading: {
        margin: 0,
    },
    input: {
        padding: "0.75rem",
        fontSize: "1rem",
    },
    button: {
        padding: "0.75rem",
        fontSize: "1rem",
        cursor: "pointer",
        borderRadius: "2rem",
        backgroundColor: "#fce8c6",
        border: "1px solid transparent",
        boxShadow: "none",
        appearance: "none",
        color: "#000",
        

    },
    error: {
        margin: 0,
        color: "red",
    },
};
